import ApiService from '@/services/api.service'


const MedicalSignsService = {
    getAll( parameter) { 
         
      const requestData = {
        method: 'get',
        url: "/MdMedicalSigns/",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber,
          NotesID : parameter.NotesID,
        }
      }     
      return ApiService.customRequest(requestData);         
    },
}
  
  export default MedicalSignsService;